import { z } from 'zod'

/** RFC 7807 problem+json body shape. */
export const ProblemSchema = z
  .object({
    type: z.string().url().default('about:blank'),
    title: z.string(),
    status: z.number().int().min(100).max(599),
    detail: z.string().optional(),
    instance: z.string().optional(),
    code: z.string().optional(),
    requestId: z.string().optional(),
  })
  .catchall(z.unknown())

export type Problem = z.infer<typeof ProblemSchema>

export class HttpProblemError extends Error {
  readonly problem: Problem

  constructor(problem: Problem) {
    super(problem.detail ?? problem.title)
    this.name = 'HttpProblemError'
    this.problem = problem
  }

  get status(): number {
    return this.problem.status
  }

  get code(): string | undefined {
    return this.problem.code
  }
}
